import { useEffect, useState } from "react";
import { useCreateRipeningEmployeeDataMutation } from "./ripeingDashboardApi";
import toast from "react-hot-toast";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import { RefreshSvg } from "../../../svgFiles/RefreshSvg";
import useTranslator from "../../../hooks/useTranslator";

const AddRipeningEmployeeData = ({ show, setShow, record }) => {
  const { _t } = useTranslator();
  const [addEmployee, { isLoading: isCreating }] =
    useCreateRipeningEmployeeDataMutation();
  const initialFormData = {
    emp_total: "",
    emp_in_cold_storage: "",
    emp_in_ripening_rooms: "",
    emp_in_sorting: "",
    emp_absent: "",
  };
  const calculateTotalEmployees = (data) => {
    return (
      Number(data.emp_in_cold_storage) +
      Number(data.emp_in_ripening_rooms) +
      Number(data.emp_in_sorting) +
      Number(data.emp_absent)
    );
  };
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    setFormData({
      ...initialFormData,
      ...record, // Automatically fills available record values
    });
  }, [show, record]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedFormData = {
      ...formData,
      [name]: value,
    };

    if (
      name === "emp_absent" ||
      name === "emp_in_sorting" ||
      name === "emp_in_ripening_rooms" ||
      name === "emp_in_cold_storage"
    ) {
      updatedFormData.emp_total =
        Number(updatedFormData.emp_absent) +
        Number(updatedFormData.emp_in_sorting) +
        Number(updatedFormData.emp_in_ripening_rooms) +
        Number(updatedFormData.emp_in_cold_storage);
    }

    setFormData(updatedFormData);
  };

  const handleSubmit = async (e) => {
    let calculatedEmp =
      formData?.emp_in_unloading +
      formData?.emp_in_washing +
      formData?.emp_absent;
    if (formData?.emp_total < calculatedEmp) {
      toast.error(
        _t("error_total_mismatch", "The total employees assigned (unloading + washing + absent) must equal the total employees entered.")
      );
      return;
    }
    e.preventDefault();
    try {
      await addEmployee(formData).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <InputWithLabel
          label={_t("total_employees", "Total Employees")}
          type="number"
          name="emp_total"
          value={calculateTotalEmployees(formData)}
          onChange={handleChange}
          placeholder={"0"}
          disabled={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("cold_storage", "Employees in Cold Storage")}
          type="number"
          name="emp_in_cold_storage"
          value={formData.emp_in_cold_storage}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("ripening_rooms", "Employees in Ripening Rooms")}
          type="number"
          name="emp_in_ripening_rooms"
          value={formData.emp_in_ripening_rooms}
          onChange={handleChange}
          icon={RefreshSvg}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("employee_sorting", "Employees in Sorting")}
          type="number"
          name="emp_in_sorting"
          value={formData.emp_in_sorting}
          onChange={handleChange}
          icon={RefreshSvg}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("employee_absent", "Absent Employees")}
          type="number"
          name="emp_absent"
          value={formData.emp_absent}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
    </>
  );
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("ripening_title", "Adding Employees Data")}
    >
      <Row>{renderFormFields()}</Row>
      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            isLoading={isCreating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default AddRipeningEmployeeData;
